import http from './httpService';

export function getSalesOffices() {
	return http.get('SalesOffice');
}
